export const BASE_PATH = "";

export const DASHBOARD_PATH = "/account-dashboard";

const config = {
  fontFamily: `'Poppins', sans-serif`, // can change font for whole admin panel
  borderRadius: 8,
  outlinedFilled: true,
  navType: "light", // light, dark
  presetColor: "default", // default, theme1, theme2, theme3, theme4, theme5, theme6
  locale: "en", // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
  rtlLayout: false,
  container: false,
};

export default config;
